export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/medical_or_pharmaceutical.201a386.svg";